export const FavOriginsActionTypes = {
  API_RESPONSE_SUCCESS: '@@favOrigins/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@favOrigins/API_RESPONSE_ERROR',

  GET_FAV_ORIGIN: '@@favOrigins/GET_FAV_ORIGIN',
  LIST_FAV_ORIGINS: '@@favOrigins/LIST_FAV_ORIGINS',
  ADD_FAV_ORIGIN: '@@favOrigins/ADD_FAV_ORIGIN',
  UPDATE_FAV_ORIGIN: '@@favOrigins/UPDATE_FAV_ORIGIN',
  DELETE_FAV_ORIGIN: '@@favOrigins/DELETE_FAV_ORIGIN',
  RESET: '@@favOrigins/RESET'
}
